const EMAIL_REGEX = /^[\w-\\.]+@([\w-]+\.)+[\w-]{2,4}$/;

export const emailFormatValidator = (email: string) => {
  const regex = new RegExp(EMAIL_REGEX);
  return regex.test(email);
};

export const encodeURL = (value?: string) => {
  if (!value) return "";
  return encodeURIComponent(value).replace(/%20/g, "+");
};

export const decodeURL = (value?: string) => {
  if (!value) return "";

  try {
    return decodeURIComponent(value.replace(/\+/g, " "));
  } catch (e) {
    return value.replace(/\+/g, " ");
  }
};

export const mergeRefs = (...refs: any[]) => {
  return (instance: HTMLInputElement) => {
    refs.forEach((ref) => {
      if (typeof ref === "function") {
        ref(instance);
      } else if (ref != null) {
        ref.current = instance;
      }
    });
  };
};

export const mergeAndRemoveDuplicates = (arr1: any[], arr2: any[]) => {
  const combineArray = [...arr1, ...arr2];
  const map = new Map();

  combineArray.forEach((item) => {
    map.set(item.node.id, item);
  });

  return Array.from(map.values());
};
